export default __webpack_public_path__ + "static/media/bag2.0c598faf.webp";